import { z } from 'zod'

export const sessionTimeoutModalSchema = z.object({
  remainingSeconds: z.number(),
})
